import { render, staticRenderFns } from "./AdminExport.vue?vue&type=template&id=9c54c622&"
import script from "./AdminExport.vue?vue&type=script&lang=js&"
export * from "./AdminExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports